























































































































import { Component, Prop, Vue } from 'vue-property-decorator'
import { Action, Getter, State } from 'vuex-class'
import { Route } from 'vue-router'

import {
  ConfirmLeaveModal,
  CreatePortionModal,
  ItemForm,
  ItemImageContainer,
  NetworkErrorEmptyState,
  UpdateImageModal,
  VsLoading
} from '@/components'

import { ListItem, MobileLayout } from '@/layouts/components'

import {
  ActionButton,
  AsyncState,
  DropDownButton,
  Item,
  ItemContext,
  ItemResourcePayload,
  ModalState,
  PortionOuterContext
} from '@/models'

import { ItemPortions } from '@/store/menu/state'
import { RootState } from '@/store/state'
import { RelationMap } from '@/store/models'

@Component({
  components: {
    ConfirmLeaveModal,
    CreatePortionModal,
    ItemForm,
    ItemImageContainer,
    ListItem,
    MobileLayout,
    NetworkErrorEmptyState,
    UpdateImageModal,
    VsLoading
  }
})
export default class ItemDetails extends Vue {
  @Prop({ type: Number, required: true })
  readonly itemGroupId!: number

  @Prop({ type: Number, required: true })
  readonly itemId!: number

  loadState = new AsyncState()
  loadPortionsState = new AsyncState()
  updateImageState = new ModalState()
  updateItemState = new AsyncState()
  confirmLeaveState = new ModalState()
  confirmAddPortionState = new ModalState()
  createPortionState = new ModalState()
  removeState = new ModalState()

  data: ItemResourcePayload | null = null
  isValid = false
  previousRoute: string | null = null

  confirmLeaveCallback: (() => void) | null = null

  get buttons (): (ActionButton | DropDownButton)[] {
    if (this.item === null) {
      return []
    }

    return [
      {
        text: 'Salvar',
        handler: this.handleSubmit,
        isDisabled: !this.hasChanges || !this.isValid || this.updateItemState.isPending
      },
      {
        icon: 'more_vert',
        color: 'dark',
        items: [
          {
            text: 'Remover',
            handler: () => {
              this.removeState.isActive = true
            }
          }
        ]
      }
    ]
  }

  get context (): ItemContext {
    return {
      id: this.itemId,
      itemGroupId: this.itemGroupId
    }
  }

  get hasChanges () {
    const data = this.data
    const item = this.item

    return data !== null && item !== null && (
      data.name !== item.name ||
      data.description !== item.description ||
      data.price !== item.price ||
      data.available !== item.isAvailable
    )
  }

  get item (): Item | null {
    return this.itemByContext(this.context)
  }

  get itemPortions (): ItemPortions | undefined {
    return this.itemsPortions[this.itemId]
  }

  get portionsTotal () {
    return this.itemPortions
      ? this.itemPortions.total
      : 0
  }

  @State((state: RootState) => state.menu.items.portions)
  readonly itemsPortions!: RelationMap<ItemPortions>

  @Getter('menu/itemByContext')
  readonly itemByContext!: (context: ItemContext) => Item | null

  @Action('menu/loadItem')
  loadItem!: (context: ItemContext) => Promise<void>

  @Action('menu/loadPortionPage')
  loadPortionPage!: (context: PortionOuterContext) => Promise<void>

  @Action('menu/updateItem')
  updateItem!: (data: { id: number; payload: ItemResourcePayload }) => Promise<void>

  @Action('menu/updateItemImage')
  updateImage!: (data: {id: number; imageFile: File }) => Promise<void>

  @Action('menu/removeItem')
  removeItem!: (data: { id: number; itemGroupId: number }) => Promise<void>

  beforeRouteEnter (to: Route, from: Route, next: Function) {
    next((vm: this) => {
      vm.previousRoute = from.name ?? null
    })
  }

  async created () {
    if (this.item === null) {
      await this.reload()
    } else {
      this.loadState.touch()
    }

    if (this.item) {
      this.data = {
        groupId: this.itemGroupId,
        name: this.item.name,
        description: this.item.description,
        price: this.item.price,
        available: this.item.isAvailable
      }
    }

    if (this.portionsTotal === 0) {
      this.handleLoadPortions()
    } else {
      this.loadPortionsState.touch()
    }
  }

  async reload () {
    try {
      await this.loadState.handle(
        this.loadItem(this.context)
      )
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error(e)
    }
  }

  async handleLoadPortions () {
    try {
      await this.loadPortionsState.handle(
        this.loadPortionPage({
          itemId: this.itemId,
          itemGroupId: this.itemGroupId
        })
      )
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error(e)
    }
  }

  async handleSubmit () {
    if (this.data === null || !this.hasChanges || !this.isValid) {
      return
    }

    try {
      await this.updateItemState.handle(
        this.updateItem({
          id: this.itemId,
          payload: this.data
        })
      )
    } catch (e) {
      this.$vs.notify({
        title: 'Não foi possível alterar.',
        color: 'danger',
        fullWidth: true
      })

      // eslint-disable-next-line no-console
      console.error(e)
    }
  }

  async handleRemove () {
    try {
      await this.removeState.handle(
        this.removeItem({
          id: this.itemId,
          itemGroupId: this.itemGroupId
        })
      )

      this.$router.back()
    } catch (e) {
      this.$vs.notify({
        title: 'Não foi possível remover.',
        color: 'danger',
        fullWidth: true
      })

      // eslint-disable-next-line no-console
      console.error(e)
    }
  }

  async handleUpdateImage (imageFile: File) {
    try {
      await this.updateImageState.handle(
        this.updateImage({
          id: this.itemId,
          imageFile
        })
      )
    } catch (e) {
      this.$vs.notify({
        title: 'Não foi possível alterar a foto.',
        color: 'danger',
        fullWidth: true
      })

      // eslint-disable-next-line no-console
      console.error(e)
    }
  }

  confirmAddPortion () {
    if (this.hasChanges) {
      this.confirmAddPortionState.isActive = true
    } else {
      this.createPortionState.isActive = true
    }
  }

  confirmLeave (callback: () => void) {
    if (this.hasChanges) {
      this.confirmLeaveCallback = callback
      this.confirmLeaveState.isActive = true
    } else {
      callback()
    }
  }

  goBack () {
    if (this.previousRoute === 'ItemGroupDetails') {
      this.$router.replace({ name: 'Items' })
    } else {
      this.$router.back()
    }
  }
}
